export const DragHandler = {
  extends: 'Icon',
  if: (el, s) => !el.getUserSettings('optimizedMode'),
  position: 'absolute',
  left: '50%',
  bottom: '-1.5em',
  transform: 'translate3d(-50%, 0, 1px)',
  icon: 'dragOutline',
  color: 'dim',
};